<template>
  <v-app>
  <v-app-bar
      app 
      top
     elevation="1"
      color="white"
      
    >
      <v-app-bar-nav-icon v-if="$store.state.user_branding.length != []  &&  $store.state.user_changes != []" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>مرکز تعمیرات ایران</v-toolbar-title>

      <v-spacer></v-spacer>

 
    </v-app-bar>




 <v-navigation-drawer
      v-model="drawer"
      fixed
      right
      temporary
    >

 <v-list>
 

        <v-list-item >
          <v-list-item-content>
            <v-list-item-title class="text-h6">
                   {{$store.state.user.first_name}}
    {{$store.state.user.last_name}}
            </v-list-item-title>
            <v-list-item-subtitle>  {{$store.state.user.mobile}}</v-list-item-subtitle>
          </v-list-item-content>

       
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list
        nav
        dense
      >
        <v-list-item-group color="primary" class="side-menu">
          
             <router-link to="/dashboard">
          <v-list-item @click="drawer = false">
             <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>داشبورد</v-list-item-title></v-list-item-content>
          </v-list-item>
             </router-link>
             
          <v-list-item @click="$store.state.financial = true;drawer = false">
            <v-list-item-icon><v-icon>mdi-credit-card-outline</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>تراکنش های مالی</v-list-item-title></v-list-item-content>
          </v-list-item>
            
            




                <v-list-item   v-if="false"   @click="$store.state.reset_password = true;drawer = false">
            <v-list-item-icon><v-icon>mdi-key</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title> تغییر رمز عبور</v-list-item-title></v-list-item-content>
          </v-list-item>

       
          
                 <v-list-item  @click="$store.state.scores = true;drawer = false">
            <v-list-item-icon><v-icon>mdi-numeric</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title> امتیازات شما</v-list-item-title></v-list-item-content>
          </v-list-item>

          
             <v-list-item   v-if="false" @click="$store.state.ratings = true;drawer = false">
            <v-list-item-icon><v-icon>mdi-format-list-numbered-rtl</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title> رتبه در فعالیت ها</v-list-item-title></v-list-item-content>
          </v-list-item>
         
            
                        <v-list-item @click="$store.state.rules = true;drawer = false">
            <v-list-item-icon><v-icon>mdi-message-text-lock</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>قوانین و مقررات</v-list-item-title></v-list-item-content>
          </v-list-item>
                      <v-list-item @click="$store.state.help = true;drawer = false">
            <v-list-item-icon><v-icon>mdi-file-question</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>  راهنما</v-list-item-title></v-list-item-content>
          </v-list-item>
          
              <v-list-item @click="log_out = true;drawer = false">
            <v-list-item-icon><v-icon>mdi-exit-to-app</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>  خروج از سامانه</v-list-item-title></v-list-item-content>
          </v-list-item>

        </v-list-item-group>
      </v-list>


    </v-navigation-drawer>

 <v-dialog
      v-model="log_out"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          خروج از سامانه
        </v-card-title>
        <v-card-text>برای خروج از سامانه مطمئنید؟</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="gray darken-1"
            
            @click="log_out = false"
          >
            انصراف
          </v-btn>
          <v-btn
            color="red darken-1"
            dark
            
            @click="log_out_function();log_out = false"
          >
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="$store.state.loginmodal"
      fullscreen
      persistent
      no-click-animation
      hide-overlay
      transition="dialog-bottom-transition"
    >
<login  />


    </v-dialog>

    <v-dialog
      v-model="$store.state.ratings"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
<ratings  />
    </v-dialog>

    <v-dialog
      v-model="$store.state.financial"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
<financial  />
    </v-dialog>

        <v-dialog
      v-model="$store.state.rules"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
<rules  />
    </v-dialog>

        <v-dialog
      v-model="$store.state.scores"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
<scores  />
    </v-dialog>

      <v-dialog
      v-model="$store.state.help"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
<help  />
    </v-dialog>






 <v-dialog
      v-model="$store.state.reset_password"
      
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">تغییر رمز عبور</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  label="رمز عبور قبلی*"
                  type="password"
                  outlined
                  required
                ></v-text-field>
              </v-col>
            <v-col cols="12" class="py-0">
                <v-text-field
                  label="رمز عبور جدید*"
                  type="password"
                  outlined
                  required
                ></v-text-field>
              </v-col>
                <v-col cols="12" class="py-0">
                <v-text-field
                outlined
                  label="تکرار رمز عبور جدید*"
                  type="password"
                  required
                ></v-text-field>
              </v-col>

           
            </v-row>
          </v-container>
      
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="$store.state.reset_password = false"
          >
            انصراف
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="$store.state.reset_password = false"
          >
            تایید
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>





    <v-main>
      <div  v-if="$store.state.user_branding.length == []  ||  $store.state.user_changes == []" style="position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    padding: 100px 0 0 0;" class="loading">
         <v-progress-circular
    
        
      indeterminate
    
    ></v-progress-circular>
    <p class="mt-3">لطفا صبر کنید </p>
      </div>
      
      <router-view  v-if="$store.state.user_branding.length != []  &&  $store.state.user_changes != []" class="grey lighten-5"/>
   
    </v-main>




<v-footer
 fixed
   app
   padless
      bottom
      flat
      elevation="1"
      class="bottom-navigation"
      color="white"
      dark
    >
        <v-bottom-navigation v-if="$store.state.user_branding.length != []  &&  $store.state.user_changes != []"
    v-model="navigation"
    grow
    light
    
    color="red"
    class="p-0 bottom-navigation"
  >
 
    <v-btn to="/dashboard">
          
      <span>داشبورد</span>

      <v-icon>mdi-view-dashboard</v-icon>
     
    </v-btn>
  
    <v-btn>
        <router-link to="/activity">
      <span>فعالیت</span>
      <v-icon>mdi-wrench</v-icon>
        </router-link>
    </v-btn>

    <v-btn>
        <router-link to="/support">
      <span>پشتیبانی</span>
      <v-icon>mdi-forum</v-icon>
        </router-link>
    </v-btn>

    <v-btn>
        <router-link to="/profile">
      <span>اطلاعات کاربری</span>
      <v-icon>mdi-account</v-icon>
        </router-link>
    </v-btn>
       <v-btn>
           <router-link to="/plan">
      <span> خرید اشتراک</span>
      <v-icon>mdi-rocket</v-icon>
        </router-link>
    </v-btn>
  </v-bottom-navigation>
</v-footer>

    
  </v-app>
</template>

<script>

  import Login from './components/login'
  import Ratings from './components/ratings'
  import Financial from './components/financial'
  import Rules from './components/rules'
  import Scores from './components/scores'
  import Help from './components/help'




export default {
  name: 'App',
    components: {
      Login,Ratings,Financial,Rules,Scores,Help
    },
    methods:{
log_out_function(){
  this.$store.state.loginmodal = true
  this.$store.state.is_login = false
  this.$store.state.user = []
  this.$cookie.delete('session');
}
    },
       mounted: function () {
     



       },
      created: function () {
      const _this = this
     
this.$moment.lang("fa")


if(this.$route.name != 'dashboard'){
// this.$router.push('dashboard')
}


if(this.$route.query.pay_id){

      senddata = {  data: {  data: ['select', 'agent_transactions', '*',{id:this.$route.query.pay_id}] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
console.log(data)
     })


}


         if(this.$store.state.cities.length == 0){
      senddata = {  data: {  data: ['select', 'cities', '*'] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
_this.$store.state.cities = data.data
     }).catch(data => {
       console.log(data)
     })
   }

   
  if(!this.$cookie.get('session')){
  
    this.$store.state.loginmodal = true
  }else{

    var senddata = {data: {  data: ['select', 'agents', '*',{session:this.$cookie.get('session')}] }, actions: ['get'] };
    this.api_get(senddata).then(data => {
if(data.data.length > 0){
  _this.$store.state.is_login = true
     data.data[0].plan_prices = JSON.parse(data.data[0].plan_prices)
   _this.$store.state.user = data.data[0]
   _this.$store.state.user_changes = data.data[0]
   var senddata = {data: {  data: ['select', 'agent_branding', '*',{id:data.data[0].branding_id}] } , actions: ['get'] };
    this.api_get(senddata).then(data => {


        var senddata = {data: {  data: ['select', 'agent_upload', '*',
        {OR:{id:[data.data[0].profile_pic,data.data[0].agreement,data.data[0].national_pic,data.data[0].evidence]}}] } , actions: ['get'] };
    _this.api_get(senddata).then(result => {
result.data.forEach(element => {

  if(element.type == 'agreements'){data.data[0].agreement_image = _this.$store.state.api_url+'uploads/agreements/'+element['name']}
  if(element.type == 'logos'){data.data[0].logo_image = _this.$store.state.api_url+'uploads/logos/'+element['name']}
  if(element.type == 'nationals'){data.data[0].national_image = _this.$store.state.api_url+'uploads/nationals/'+element['name']}
  if(element.type == 'evidences'){data.data[0].evidence_image = _this.$store.state.api_url+'uploads/evidences/'+element['name']}
});
    })

     data.data[0].cities = data.data[0].cities.split(',')
     data.data[0].device_activity = JSON.parse(data.data[0].device_activity)
   _this.$store.state.user_branding = data.data[0]
   _this.$store.state.user_branding_changes = data.data[0]
    })
}else{
  _this.$store.state.is_login = false
  _this.$cookie.delete('session');
     _this.$store.state.loginmodal = true
}
     })

  }
  },
    

  data: () => ({
    log_out:false,
    navigation : true,
    drawer : false
  }),
};
</script>
